export enum WidgetStatePlaceholderEnum {
  DATA_NOT_AVAILABLE = 'not-available',
  DATA_NOT_FOUND = 'not-found'
}
